export const categories = [
  {
    key: 'news',
    name: '新闻',
    description: '时政、经济、民生与社会热点',
    icon: 'ri-newspaper-line',
    intro: '聚焦国内外时政要闻、经济走势与民生热点，第一时间为你梳理事件脉络，呈现权威、客观、有深度的新闻资讯。',
  },
  {
    key: 'entertainment',
    name: '娱乐',
    description: '影视、音乐、综艺与行业动态',
    icon: 'ri-movie-2-line',
    intro: '汇集影视、音乐、综艺与网络视听的最新动态，从票房数据到口碑讨论，带你轻松掌握娱乐圈的热门话题。',
  },
  {
    key: 'life',
    name: '生活',
    description: '健康、家居、出行与实用技巧',
    icon: 'ri-leaf-line',
    intro: '分享健康养生、家居收纳、出行游玩与日常实用技巧，用接地气的方法帮你把生活过得更有品质。',
  },
];

export const newsArticles = [
  {
    id: 'n01',
    title: '全国多地上调最低工资标准 切实兜牢民生底线',
    summary: '近期多个省市陆续公布新一轮最低工资标准调整方案，涉及制造业、服务业等大量一线岗位，进一步织密民生保障网。',
    category: 'news',
    tags: ['突发', '民生'],
    author: '9·1牛网 时政组',
    publishTime: '2026-10-09T08:30:00',
    readCount: 15820,
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20city%20workers%20silhouettes%20walking%20toward%20a%20bright%20horizon%20in%20deep%20navy%20and%20orange%20tones%2C%20clean%20geometric%20shapes%2C%20modern%20news%20graphic%20style%2C%20minimal%20flat%20design%2C%20high%20contrast%2C%20no%20text&width=800&height=450&seq=newscov-n01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近日，多个省份人力资源和社会保障部门陆续发布通知，明确自本月起上调本地区最低工资标准。本轮调整覆盖制造业、批发零售、住宿餐饮、居民服务等劳动密集型行业的大量一线岗位。' },
      { type: 'paragraph', text: '相关部门负责人表示，最低工资标准根据当地经济发展水平、物价变动情况和就业状况等因素综合测算确定，既保障劳动者基本生活，也兼顾企业承受能力，力求在两者之间取得平衡。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20diverse%20workers%20in%20various%20uniforms%20standing%20together%20in%20front%20of%20a%20city%20skyline%2C%20navy%20blue%20and%20warm%20orange%20palette%2C%20clean%20editorial%20graphic%20style%2C%20geometric%20background%2C%20no%20text&width=1000&height=560&seq=newsbody-n01&orientation=landscape', caption: '多地明确新一轮最低工资标准调整方案（示意图）' },
      { type: 'paragraph', text: '业内分析认为，最低工资标准的上调将在一定程度上带动低薪岗位薪酬结构的变化，同时也会对社保缴费基数、加班费计算等产生连锁影响，企业与劳动者都应及时了解本地最新政策细则。' },
      { type: 'heading', text: '落实情况持续跟踪' },
      { type: 'paragraph', text: '各地明确要求用人单位在新标准施行后按时足额发放工资，劳动者如遇权益受损，可通过当地人社部门热线或线上平台进行咨询与投诉。' },
    ],
  },
  {
    id: 'n02',
    title: '前三季度经济运行数据发布 主要指标稳中有进',
    summary: '统计部门最新数据显示，前三季度国内经济运行总体平稳，消费、投资、外贸等多个领域呈现恢复向好态势。',
    category: 'news',
    tags: ['深度', '经济'],
    author: '9·1牛网 财经组',
    publishTime: '2026-10-08T10:15:00',
    readCount: 13260,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20data%20visualization%20style%20illustration%20with%20rising%20bar%20charts%20and%20trend%20lines%20in%20deep%20blue%20and%20orange%2C%20abstract%20financial%20report%20background%2C%20minimal%20modern%20flat%20design%2C%20high%20contrast%2C%20no%20text&width=800&height=450&seq=newscov-n02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '统计部门日前发布前三季度经济运行主要数据。数据显示，国民经济运行总体平稳，生产需求稳步回升，就业物价总体稳定，高质量发展扎实推进。' },
      { type: 'paragraph', text: '从结构上看，高技术制造业和现代服务业增长较快，消费对经济增长的贡献率保持在较高水平，新能源、数字经济等新动能持续释放活力。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%20dashboard%20illustration%20with%20multiple%20charts%20and%20graphs%20in%20navy%20blue%20and%20orange%20accent%2C%20clean%20flat%20business%20infographic%20style%2C%20geometric%20layout%2C%20no%20text&width=1000&height=560&seq=newsbody-n02&orientation=landscape', caption: '前三季度主要经济指标概览（示意图）' },
      { type: 'paragraph', text: '专家指出，下阶段仍需持续扩大有效需求，稳定市场预期，推动各项存量与增量政策落地见效，巩固经济回升向好的基础。' },
    ],
  },
  {
    id: 'n03',
    title: '多部门联合部署秋冬季大气污染防治攻坚行动',
    summary: '多部门联合印发方案，围绕工业排放、扬尘治理、机动车尾气等重点领域，部署秋冬季大气污染防治工作。',
    category: 'news',
    tags: ['观察', '民生'],
    author: '9·1牛网 环境组',
    publishTime: '2026-10-07T14:40:00',
    readCount: 8760,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20clear%20blue%20sky%20over%20a%20green%20city%20with%20clean%20air%20symbols%2C%20abstract%20environmental%20graphic%20in%20teal%20and%20orange%2C%20minimal%20flat%20editorial%20design%2C%20no%20text&width=800&height=450&seq=newscov-n03&orientation=landscape',
    content: [
      { type: 'paragraph', text: '为持续改善空气质量，多部门近日联合印发工作方案，对秋冬季大气污染防治作出系统部署，明确重点区域、重点行业与重点时段的管控要求。' },
      { type: 'paragraph', text: '方案提出，要在工业源、移动源、扬尘源等方面加强协同治理，同时保障群众温暖过冬，避免简单化、一刀切的做法。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20wind%20turbines%20and%20clean%20city%20buildings%20under%20a%20bright%20sky%2C%20teal%20and%20orange%20color%20palette%2C%20minimal%20flat%20environmental%20design%2C%20clean%20composition%2C%20no%20text&width=1000&height=560&seq=newsbody-n03&orientation=landscape', caption: '秋冬季大气污染防治重点领域（示意图）' },
      { type: 'paragraph', text: '业内人士表示，随着治理措施不断细化，大气污染防治正从末端治理向源头减排、结构调整转变，绿色低碳发展的长效机制正在形成。' },
    ],
  },
  {
    id: 'n04',
    title: '新一代高铁线路正式开通运营 区域通行时间大幅缩短',
    summary: '新一条高速铁路于近日正式开通运营，沿线多座城市间的通行时间明显缩短，区域经济联系进一步紧密。',
    category: 'news',
    tags: ['突发', '交通'],
    author: '9·1牛网 交通组',
    publishTime: '2026-10-06T09:05:00',
    readCount: 11430,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20sleek%20high%20speed%20train%20gliding%20through%20a%20stylized%20landscape%20in%20navy%20blue%20and%20orange%2C%20minimal%20geometric%20design%2C%20clean%20editorial%20graphic%2C%20no%20text&width=800&height=450&seq=newscov-n04&orientation=landscape',
    content: [
      { type: 'paragraph', text: '备受关注的新一代高速铁路线路近日正式开通运营。首发列车平稳驶出车站，标志着沿线地区正式迈入高铁时代，城市之间的时空距离被显著压缩。' },
      { type: 'paragraph', text: '据运营方介绍，该线路设计时速高、技术标准先进，采用了多项智能化运营与运维系统，为旅客提供更加安全舒适的出行体验。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20modern%20train%20station%20interior%20with%20travelers%20and%20departure%20boards%2C%20navy%20and%20orange%20palette%2C%20clean%20flat%20editorial%20style%2C%20geometric%20shapes%2C%20no%20text&width=1000&height=560&seq=newsbody-n04&orientation=landscape', caption: '新线路开通后旅客出行更加便捷（示意图）' },
      { type: 'paragraph', text: '分析人士认为，线路的开通将有效带动沿线旅游、商贸与产业协作，为区域协调发展注入新动力。' },
    ],
  },
  {
    id: 'n05',
    title: '全国秋粮收购工作全面展开 收购进度总体顺利',
    summary: '随着秋收推进，主产区秋粮收购工作陆续启动，各地多措并举保障农民售粮顺畅、价格合理。',
    category: 'news',
    tags: ['民生', '观察'],
    author: '9·1牛网 三农组',
    publishTime: '2026-10-05T16:20:00',
    readCount: 6420,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20golden%20grain%20fields%20at%20harvest%20time%2C%20abstract%20agricultural%20graphic%20in%20amber%20and%20deep%20blue%2C%20minimal%20editorial%20style%2C%20clean%20composition%2C%20no%20text&width=800&height=450&seq=newscov-n05&orientation=landscape',
    content: [
      { type: 'paragraph', text: '当前正值秋收秋种关键时期，主产区秋粮收购工作已全面展开。各地粮食和物资储备部门积极组织收储库点，方便农民就近售粮。' },
      { type: 'paragraph', text: '为保障农民利益，多地同步启动最低收购价预案，并加大对粮食质量的检测服务力度，让农户售粮更加省心。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20farmers%20and%20grain%20sacks%20at%20a%20collection%20point%2C%20amber%20and%20navy%20tones%2C%20minimal%20flat%20editorial%20graphic%20style%2C%20clean%20geometric%20background%2C%20no%20text&width=1000&height=560&seq=newsbody-n05&orientation=landscape', caption: '各地多措并举保障秋粮收购顺利（示意图）' },
      { type: 'paragraph', text: '业内人士提醒，农户在售粮过程中应注意保留凭证、了解收购价格，遇到压级压价等情况可及时向有关部门反映。' },
    ],
  },
  {
    id: 'n06',
    title: '数字人民币试点范围进一步扩大 应用场景更加丰富',
    summary: '数字人民币试点持续扩容，覆盖零售消费、公共交通、政务缴费等更多场景，用户体验不断优化。',
    category: 'news',
    tags: ['深度', '经济'],
    author: '9·1牛网 财经组',
    publishTime: '2026-10-04T11:50:00',
    readCount: 9180,
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20a%20smartphone%20with%20digital%20payment%20symbols%20floating%20around%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20flat%20fintech%20design%2C%20clean%20geometric%20background%2C%20no%20text&width=800&height=450&seq=newscov-n06&orientation=landscape',
    content: [
      { type: 'paragraph', text: '数字人民币试点范围近日进一步扩大，新增多个试点城市与特色场景，覆盖零售消费、公共交通、政务缴费、医疗教育等多种日常支付需求。' },
      { type: 'paragraph', text: '相关人士介绍，数字人民币在设计上强调普惠与安全，支持双离线支付等特色功能，有助于提升支付体系的韧性与包容性。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20diverse%20people%20using%20mobile%20payments%20in%20a%20city%2C%20navy%20and%20orange%20palette%2C%20modern%20fintech%20editorial%20style%2C%20clean%20composition%2C%20no%20text&width=1000&height=560&seq=newsbody-n06&orientation=landscape', caption: '数字人民币应用场景持续拓展（示意图）' },
      { type: 'paragraph', text: '专家表示，随着生态不断完善，数字人民币将在促进消费、服务实体经济等方面发挥更积极的作用。' },
    ],
  },
  {
    id: 'n07',
    title: '多所高校公布最新招生政策调整 更加注重综合素质',
    summary: '多所高校陆续发布新一年度招生政策，在专业设置、选考科目与综合评价等方面作出调整，强调对学生综合素质的考察。',
    category: 'news',
    tags: ['热议', '教育'],
    author: '9·1牛网 教育组',
    publishTime: '2026-10-03T15:10:00',
    readCount: 10240,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20flat%20illustration%20of%20graduation%20caps%20and%20books%20with%20a%20university%20building%20silhouette%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%2C%20geometric%20background%2C%20no%20text&width=800&height=450&seq=newscov-n07&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近期，多所高校陆续公布新一年度招生政策。与往年相比，部分高校在专业组设置、选考科目要求以及综合评价录取方式上作出了新的调整。' },
      { type: 'paragraph', text: '不少院校表示，将更加注重对学生学科基础、实践能力与综合素质的考察，鼓励学生结合兴趣与特长理性选择专业。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20students%20studying%20with%20laptops%20and%20books%20in%20a%20bright%20library%2C%20navy%20and%20orange%20tones%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=newsbody-n07&orientation=landscape', caption: '高校招生更加注重综合素质（示意图）' },
      { type: 'paragraph', text: '教育专家建议，考生与家长应及时关注目标院校官方发布的招生章程，提前了解选考科目要求与录取规则，避免因信息不对称影响报考。' },
    ],
  },
  {
    id: 'n08',
    title: '全国安全生产专项整治行动启动 聚焦重点行业领域',
    summary: '相关部门部署开展安全生产专项整治行动，聚焦矿山、危化品、建筑施工等重点行业，全面排查风险隐患。',
    category: 'news',
    tags: ['突发', '民生'],
    author: '9·1牛网 时政组',
    publishTime: '2026-10-02T09:40:00',
    readCount: 7310,
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20safety%20themed%20flat%20illustration%20with%20helmet%20and%20shield%20motifs%20in%20navy%20blue%20and%20orange%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20geometric%20background%2C%20no%20text&width=800&height=450&seq=newscov-n08&orientation=landscape',
    content: [
      { type: 'paragraph', text: '为切实防范化解重大安全风险，相关部门近日部署开展安全生产专项整治行动，聚焦矿山、危险化学品、建筑施工、城镇燃气等重点行业领域。' },
      { type: 'paragraph', text: '行动要求各地区、各企业压实安全生产责任，全面排查治理风险隐患，健全长效机制，坚决遏制重特大事故发生。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20inspectors%20checking%20industrial%20equipment%20with%20clipboards%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=newsbody-n08&orientation=landscape', caption: '重点行业领域全面排查风险隐患（示意图）' },
      { type: 'paragraph', text: '业内提示，企业应结合自身实际完善应急预案并组织演练，提升一线员工的安全意识与应急处置能力。' },
    ],
  },
  {
    id: 'n09',
    title: '医保药品目录调整 更多创新药纳入报销范围',
    summary: '新一轮医保药品目录调整工作有序推进，一批临床价值高、患者需求大的药品有望纳入报销范围，减轻用药负担。',
    category: 'news',
    tags: ['民生', '深度'],
    author: '9·1牛网 健康组',
    publishTime: '2026-10-01T13:25:00',
    readCount: 9650,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20flat%20illustration%20of%20medical%20capsules%20and%20a%20shield%20with%20a%20cross%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20healthcare%20editorial%20graphic%2C%20geometric%20background%2C%20no%20text&width=800&height=450&seq=newscov-n09&orientation=landscape',
    content: [
      { type: 'paragraph', text: '新一轮医保药品目录调整工作正有序推进。通过谈判与竞价机制，一批临床价值高、患者需求大的创新药有望被纳入报销范围，进一步减轻群众用药负担。' },
      { type: 'paragraph', text: '相关部门表示，目录调整坚持保基本、可持续的原则，兼顾创新激励与基金安全，让更多好药以合理价格惠及患者。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20pharmacists%20and%20medicine%20shelves%20in%20a%20modern%20pharmacy%2C%20navy%20and%20orange%20tones%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=newsbody-n09&orientation=landscape', caption: '更多创新药有望纳入医保报销（示意图）' },
      { type: 'paragraph', text: '有临床医生表示，目录调整落地后，患者用药选择将更加丰富，长期治疗的经济压力也有望得到缓解。' },
    ],
  },
  {
    id: 'e01',
    title: '年度国产电影市场表现亮眼 多部作品口碑票房双收',
    summary: '本年度国产电影市场佳作频出，多部现实题材与类型片作品在票房与口碑上均取得不俗成绩，观众观影热情持续高涨。',
    category: 'entertainment',
    tags: ['热议', '影视'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-08T19:00:00',
    readCount: 21460,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinema%20themed%20flat%20illustration%20with%20film%20reels%20and%20a%20spotlight%2C%20deep%20blue%20and%20vibrant%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20geometric%20background%2C%20no%20text&width=800&height=450&seq=entcov-e01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '本年度国产电影市场表现亮眼，多部作品在票房与口碑上实现双收。现实题材影片凭借扎实的叙事与真挚的情感，赢得观众的广泛共鸣。' },
      { type: 'paragraph', text: '与此同时，科幻、悬疑、动画等类型片也在制作水准上不断突破，丰富了观众的观影选择。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20an%20audience%20in%20a%20movie%20theater%20watching%20a%20bright%20screen%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e01&orientation=landscape', caption: '观众观影热情持续高涨（示意图）' },
      { type: 'paragraph', text: '业内人士分析，内容质量与观众口碑正成为影响影片长线表现的关键因素，优质内容的市场回报愈发明显。' },
    ],
  },
  {
    id: 'e02',
    title: '多部现实题材剧集宣布定档 聚焦普通人生活',
    summary: '多部现实题材剧集近日官宣定档，作品将镜头对准普通人的工作与生活，引发观众对相关话题的讨论。',
    category: 'entertainment',
    tags: ['热议', '剧集'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-07T20:30:00',
    readCount: 15680,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20retro%20television%20screen%20with%20city%20scenes%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-e02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近日，多部现实题材剧集接连官宣定档。这些作品将镜头对准普通人，围绕职场、家庭、亲情等话题展开叙事。' },
      { type: 'paragraph', text: '主创团队表示，希望通过细腻的人物刻画与生活化的细节，让观众在故事中看到自己的影子，并从中获得共鸣与思考。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20diverse%20characters%20in%20everyday%20life%20settings%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e02&orientation=landscape', caption: '现实题材剧集聚焦普通人生活（示意图）' },
      { type: 'paragraph', text: '有评论认为，现实题材创作正朝着更细致、更贴近生活的方向发展，观众对真实感与共鸣度的要求也在不断提高。' },
    ],
  },
  {
    id: 'e03',
    title: '音乐节热潮带动城市文旅消费 释放年轻活力',
    summary: '各地音乐节轮番上演，吸引大批年轻观众跨城参与，带动交通、住宿、餐饮等相关消费升温。',
    category: 'entertainment',
    tags: ['热议', '音乐'],
    author: '9·1牛网 文旅组',
    publishTime: '2026-10-06T21:10:00',
    readCount: 12980,
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20flat%20illustration%20of%20a%20music%20festival%20crowd%20with%20lights%20and%20stage%2C%20deep%20blue%20and%20energetic%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20no%20text&width=800&height=450&seq=entcov-e03&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近段时间，各类音乐节在多地轮番上演，不少观众为了一场演出跨城出行，让音乐节成为带动城市文旅消费的一股热潮。' },
      { type: 'paragraph', text: '演出期间，周边交通、住宿、餐饮、文创等消费明显升温，一些城市还推出联动优惠，延长游客停留时间。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20festival%20street%20with%20food%20stalls%20and%20neon%20signs%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e03&orientation=landscape', caption: '音乐节带火周边消费（示意图）' },
      { type: 'paragraph', text: '业内人士提醒，主办方应做好现场组织与安全保障，同时提升服务品质，让热度能够转化为可持续的城市吸引力。' },
    ],
  },
  {
    id: 'e04',
    title: '经典国漫IP改编动画发布预告 画面质感获好评',
    summary: '一部由经典国漫IP改编的动画作品发布最新预告，精致的画面与还原度较高的角色设计获得网友好评。',
    category: 'entertainment',
    tags: ['热议', '动漫'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-05T18:45:00',
    readCount: 18320,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20inspired%20flat%20illustration%20of%20a%20hero%20silhouette%20against%20a%20dramatic%20sky%2C%20deep%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20no%20text&width=800&height=450&seq=entcov-e04&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近日，一部由经典国漫IP改编的动画作品发布最新预告。预告中精致的画面、流畅的动作场面与还原度较高的角色设计，迅速引发网友讨论。' },
      { type: 'paragraph', text: '制作方透露，团队在美术风格与叙事节奏上反复打磨，力求在尊重原作的基础上，为观众带来全新的视听体验。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20animated%20characters%20in%20a%20stylized%20world%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e04&orientation=landscape', caption: '改编动画画面质感获好评（示意图）' },
      { type: 'paragraph', text: '不少观众表示期待正式上线，同时也希望作品能在剧情与情感表达上不负经典IP的口碑。' },
    ],
  },
  {
    id: 'e05',
    title: '综艺市场迎来创新季 新类型节目不断涌现',
    summary: '新一季综艺市场中，多种新类型节目陆续上线，从生活方式到职业体验，题材更加细分多元。',
    category: 'entertainment',
    tags: ['观察', '综艺'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-04T17:30:00',
    readCount: 8940,
    cover: 'https://readdy.ai/api/search-image?query=Playful%20flat%20illustration%20of%20a%20tv%20studio%20with%20colorful%20lights%20and%20microphones%2C%20deep%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20no%20text&width=800&height=450&seq=entcov-e05&orientation=landscape',
    content: [
      { type: 'paragraph', text: '新一季综艺市场迎来创新季，多种新类型节目陆续上线。除传统的竞技与选秀外，生活方式、职业体验、旅行探索等题材不断涌现。' },
      { type: 'paragraph', text: '业内观察，观众对内容的偏好日益细分，节目创作也更加注重真实感与情感联结，而非单纯依靠明星效应。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20diverse%20panel%20of%20people%20on%20a%20talk%20show%20set%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e05&orientation=landscape', caption: '综艺题材更加细分多元（示意图）' },
      { type: 'paragraph', text: '分析人士认为，能否形成持续的话题与口碑，将决定一档新节目能否在激烈竞争中走得更远。' },
    ],
  },
  {
    id: 'e06',
    title: '演唱会经济持续升温 门票开售即被抢空',
    summary: '多场大型演唱会门票开售即被抢空，跨城观演成为常态，演出经济的热度仍在延续。',
    category: 'entertainment',
    tags: ['热议', '演出'],
    author: '9·1牛网 文旅组',
    publishTime: '2026-10-03T20:05:00',
    readCount: 16720,
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20flat%20illustration%20of%20a%20concert%20stage%20with%20spotlights%20and%20crowd%20hands%2C%20deep%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20no%20text&width=800&height=450&seq=entcov-e06&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近期，多场大型演唱会门票开售即被抢空，跨城观演成为不少粉丝的常态，演出经济的热度仍在延续。' },
      { type: 'paragraph', text: '演出市场的活跃，也带动了场馆运营、舞台制作、票务服务等相关产业链的发展，为城市夜间经济增添活力。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20fans%20with%20light%20sticks%20outside%20a%20stadium%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e06&orientation=landscape', caption: '跨城观演成为常态（示意图）' },
      { type: 'paragraph', text: '消费者权益人士提示，购票时应选择正规渠道，谨防高价黄牛与假票风险，理性看待演出消费。' },
    ],
  },
  {
    id: 'e07',
    title: '青年演员群体崛起 扎实演技获观众认可',
    summary: '一批青年演员凭借扎实的表演功底受到关注，他们通过一个个角色积累口碑，逐渐成长为行业的中坚力量。',
    category: 'entertainment',
    tags: ['深度', '影视'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-02T18:20:00',
    readCount: 11240,
    cover: 'https://readdy.ai/api/search-image?query=Refined%20flat%20illustration%20of%20stage%20curtains%20and%20a%20star%20motif%2C%20deep%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-e07&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近两年，一批青年演员凭借扎实的表演功底走进大众视野。他们并不依赖流量话题，而是通过一个个角色慢慢积累口碑。' },
      { type: 'paragraph', text: '影视从业者评价，随着市场对内容质量的要求提高，演员的专业能力正重新成为评价的核心标准。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20actors%20rehearsing%20on%20a%20stage%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e07&orientation=landscape', caption: '专业能力重回评价核心（示意图）' },
      { type: 'paragraph', text: '观众也逐渐形成更理性的审美取向，愿意为真正打动人心的表演买单，这为踏实打磨演技的年轻人提供了更多机会。' },
    ],
  },
  {
    id: 'e08',
    title: '纪录片《大地之上》口碑爆棚 用镜头记录平凡生活',
    summary: '纪录片《大地之上》凭借细腻的镜头语言与真挚的人文关怀收获高口碑，让更多人关注到平凡生活中的动人瞬间。',
    category: 'entertainment',
    tags: ['深度', '纪录片'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-10-01T19:40:00',
    readCount: 9870,
    cover: 'https://readdy.ai/api/search-image?query=Serene%20flat%20illustration%20of%20rolling%20hills%20and%20a%20camera%20silhouette%2C%20deep%20blue%20and%20warm%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-e08&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近日上线的纪录片《大地之上》获得较高口碑。影片以平实的视角记录普通人的日常，通过细腻的镜头语言传递出温暖的人文关怀。' },
      { type: 'paragraph', text: '主创团队表示，拍摄过程历时较长，团队深入不同地区，只为真实呈现那些容易被忽略的动人瞬间。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20documentary%20crew%20filming%20in%20nature%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e08&orientation=landscape', caption: '用镜头记录平凡生活（示意图）' },
      { type: 'paragraph', text: '不少观众留言称，纪录片让人重新审视身边的日常，也让人对生活多了一份珍惜。' },
    ],
  },
  {
    id: 'e09',
    title: '短视频平台发力微短剧赛道 内容质量成关键',
    summary: '多家短视频平台加大微短剧投入，题材与制作水准不断提升，行业竞争逐渐从数量转向质量。',
    category: 'entertainment',
    tags: ['观察', '新媒体'],
    author: '9·1牛网 娱乐组',
    publishTime: '2026-09-30T16:00:00',
    readCount: 10460,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20smartphone%20with%20play%20buttons%20and%20short%20video%20frames%2C%20deep%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20no%20text&width=800&height=450&seq=entcov-e09&orientation=landscape',
    content: [
      { type: 'paragraph', text: '近期，多家短视频平台加大了对微短剧的投入，不仅数量增长明显，题材类型与制作水准也在不断提升。' },
      { type: 'paragraph', text: '平台方表示，将继续扶持优质创作团队，鼓励在叙事、表演与制作上精益求精，推动行业健康发展。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20production%20crew%20shooting%20a%20short%20film%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=entbody-e09&orientation=landscape', caption: '微短剧行业竞争转向质量（示意图）' },
      { type: 'paragraph', text: '业内分析，随着用户审美提升，靠套路与爽感堆砌的内容生命力有限，扎实的剧本与用心的制作才是长久之计。' },
    ],
  },
  {
    id: 'l01',
    title: '秋季养生指南：科学膳食与作息安排',
    summary: '秋季气候干燥、昼夜温差大，合理的膳食搭配与规律的作息安排，有助于身体平稳适应季节变化。',
    category: 'life',
    tags: ['实用', '健康'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-09T07:50:00',
    readCount: 18960,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20autumn%20fruits%20and%20tea%20on%20a%20wooden%20table%2C%20amber%20and%20deep%20blue%20palette%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-l01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '进入秋季后，气候逐渐干燥，昼夜温差加大，人体容易出现口干、乏力、睡眠质量下降等情况。合理安排膳食与作息，有助于平稳度过季节交替。' },
      { type: 'heading', text: '一、润燥膳食搭配' },
      { type: 'paragraph', text: '日常饮食可适当增加富含水分与维生素的蔬果，如梨、银耳、百合等，同时减少过于辛辣刺激的食物，避免加重干燥带来的不适。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20healthy%20autumn%20foods%20like%20pears%20and%20porridge%2C%20warm%20amber%20and%20navy%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l01&orientation=landscape', caption: '秋季饮食宜润燥（示意图）' },
      { type: 'heading', text: '二、规律作息与适度运动' },
      { type: 'paragraph', text: '保持规律的作息、避免熬夜，有助于维持身体机能。天气晴好时可进行散步、慢跑等适度运动，增强体质但不宜过度疲劳。' },
      { type: 'paragraph', text: '此外，注意根据气温变化及时增减衣物，尤其是早晚时段，减少着凉感冒的风险。' },
    ],
  },
  {
    id: 'l02',
    title: '家庭收纳技巧：让小空间焕然一新',
    summary: '掌握分类、垂直利用与定期整理三个原则，即使空间有限，也能让家中整洁有序、取用方便。',
    category: 'life',
    tags: ['实用', '家居'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-08T09:20:00',
    readCount: 14320,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20flat%20illustration%20of%20organized%20shelves%20with%20baskets%20and%20plants%2C%20navy%20blue%20and%20warm%20orange%20palette%2C%20minimal%20interior%20editorial%20style%2C%20no%20text&width=800&height=450&seq=entcov-l02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '空间有限并不等于杂乱无章。掌握几个简单的收纳原则，就能让家中保持整洁，也让日常取用更加高效。' },
      { type: 'heading', text: '分类与就近原则' },
      { type: 'paragraph', text: '先按用途把物品分类，再把它们存放在使用频率最高的区域。常用的物品放在伸手可及处，季节性物品则可以收进高层或床下。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20tidy%20closet%20with%20folded%20clothes%20and%20boxes%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l02&orientation=landscape', caption: '分类收纳让取用更方便（示意图）' },
      { type: 'heading', text: '垂直空间与定期整理' },
      { type: 'paragraph', text: '墙面、柜门内侧和门后都是容易被忽略的空间，善用挂钩与收纳袋可以释放不少地面空间。同时建议每季度整理一次，及时处理不再需要的物品。' },
    ],
  },
  {
    id: 'l03',
    title: '换季时节如何科学预防流感',
    summary: '随着气温下降，流感进入高发期。保持良好的卫生习惯、及时接种疫苗与充足休息，是预防流感的有效方式。',
    category: 'life',
    tags: ['实用', '健康'],
    author: '9·1牛网 健康组',
    publishTime: '2026-10-07T08:10:00',
    readCount: 13260,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20flat%20illustration%20of%20protective%20health%20symbols%20like%20masks%20and%20soap%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20healthcare%20editorial%20style%2C%20no%20text&width=800&height=450&seq=entcov-l03&orientation=landscape',
    content: [
      { type: 'paragraph', text: '随着气温下降，流感进入高发季节。科学预防不仅能降低感染风险，也能减少对工作与生活的影响。' },
      { type: 'heading', text: '日常防护要点' },
      { type: 'paragraph', text: '勤洗手、常通风、在人群密集场所佩戴口罩，都是简单有效的防护措施。咳嗽或打喷嚏时注意遮挡，避免用手直接触碰口鼻。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20person%20washing%20hands%20and%20ventilating%20a%20room%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l03&orientation=landscape', caption: '良好卫生习惯是预防关键（示意图）' },
      { type: 'heading', text: '疫苗与就医' },
      { type: 'paragraph', text: '接种流感疫苗是预防流感的有效手段，尤其建议老人、儿童及有基础疾病的人群在医生指导下接种。若出现持续高热等症状，应及时就医。' },
    ],
  },
  {
    id: 'l04',
    title: '通勤族的高效时间管理方法',
    summary: '把碎片化时间用起来，通勤路上也能完成学习、规划与放松，让每天的两小时产生更多价值。',
    category: 'life',
    tags: ['实用', '职场'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-06T07:40:00',
    readCount: 11280,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20commuter%20with%20headphones%20and%20a%20planner%20on%20a%20train%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=450&seq=entcov-l04&orientation=landscape',
    content: [
      { type: 'paragraph', text: '对许多上班族来说，每天往返通勤要花费不少时间。如果加以规划，这段碎片时间其实可以发挥不小的价值。' },
      { type: 'heading', text: '提前规划与任务拆分' },
      { type: 'paragraph', text: '不妨在前一晚列出第二天要完成的三件事，通勤时用几分钟确认优先级，让到岗后能更快进入状态。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20person%20listening%20to%20audio%20lessons%20on%20a%20bus%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l04&orientation=landscape', caption: '碎片时间也能产生价值（示意图）' },
      { type: 'heading', text: '学习与放松兼顾' },
      { type: 'paragraph', text: '可以听播客、有声书或语言课程来利用听觉时间，也别忘了给大脑留一点放空的空间。适度放松能让一天的情绪更稳定。' },
    ],
  },
  {
    id: 'l05',
    title: '城市露营地推荐：周末亲近自然',
    summary: '不用远行也能拥抱自然，越来越多的城市近郊露营地成为周末放松身心的好去处。',
    category: 'life',
    tags: ['实用', '出行'],
    author: '9·1牛网 文旅组',
    publishTime: '2026-10-05T10:30:00',
    readCount: 12140,
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20tent%20and%20campfire%20under%20a%20starry%20sky%2C%20deep%20blue%20and%20warm%20orange%20palette%2C%20minimal%20editorial%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-l05&orientation=landscape',
    content: [
      { type: 'paragraph', text: '周末想亲近自然，又不想长途奔波？近年来，城市近郊兴起了不少设施完善的露营地，成为都市人放松身心的新选择。' },
      { type: 'heading', text: '选择营地的建议' },
      { type: 'paragraph', text: '挑选营地时可关注交通便利性、基础设施与安全条件。初次体验者可以选择提供装备租赁与活动组织的营地，降低入门门槛。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20friends%20enjoying%20a%20picnic%20at%20a%20lakeside%20camp%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l05&orientation=landscape', caption: '近郊露营成为周末新选择（示意图）' },
      { type: 'heading', text: '文明露营需注意' },
      { type: 'paragraph', text: '露营时应遵守场地规定，带走垃圾、注意用火安全，尽量减少对自然环境的打扰，让美好风景能够长久留存。' },
    ],
  },
  {
    id: 'l06',
    title: '家电省电小妙招：账单立省三成',
    summary: '调整几个日常用电习惯，合理使用空调、冰箱与待机设备，家庭电费就能明显下降。',
    category: 'life',
    tags: ['实用', '家居'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-04T15:00:00',
    readCount: 15640,
    cover: 'https://readdy.ai/api/search-image?query=Clean%20flat%20illustration%20of%20home%20appliances%20with%20energy%20saving%20symbols%2C%20navy%20blue%20and%20orange%20palette%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=450&seq=entcov-l06&orientation=landscape',
    content: [
      { type: 'paragraph', text: '电费账单常常在不知不觉中攀升，其实只要调整一些日常用电习惯，就能在保证舒适的前提下有效省电。' },
      { type: 'heading', text: '空调与冰箱' },
      { type: 'paragraph', text: '空调温度每调高一度，耗电会相应减少，夏季建议设置在合理区间并配合定时与睡眠模式。冰箱则应避免频繁开门，摆放时留出散热空间。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20energy%20efficient%20appliances%20in%20a%20home%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l06&orientation=landscape', caption: '合理使用家电可明显省电（示意图）' },
      { type: 'heading', text: '待机与照明' },
      { type: 'paragraph', text: '长期不用的电器建议拔掉插头，减少待机耗电。照明方面，可逐步更换为节能灯具，并养成随手关灯的习惯。' },
    ],
  },
  {
    id: 'l07',
    title: '亲子阅读习惯培养的五个建议',
    summary: '从营造环境到陪伴共读，几个简单的方法能帮助孩子爱上阅读，也让亲子关系更加亲密。',
    category: 'life',
    tags: ['实用', '教育'],
    author: '9·1牛网 教育组',
    publishTime: '2026-10-03T11:20:00',
    readCount: 9980,
    cover: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20a%20parent%20reading%20a%20book%20with%20a%20child%2C%20orange%20and%20deep%20blue%20palette%2C%20minimal%20editorial%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-l07&orientation=landscape',
    content: [
      { type: 'paragraph', text: '阅读习惯的养成并非一蹴而就。与其强迫孩子读书，不如通过环境与陪伴，让阅读自然成为生活的一部分。' },
      { type: 'heading', text: '一、营造阅读环境' },
      { type: 'paragraph', text: '在家里设置一个安静舒适的小角落，让书本触手可及。父母自己放下手机拿起书，往往比反复催促更有效。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20cozy%20reading%20corner%20with%20bookshelf%20and%20cushions%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l07&orientation=landscape', caption: '营造舒适的阅读环境（示意图）' },
      { type: 'heading', text: '二、尊重兴趣与陪伴共读' },
      { type: 'paragraph', text: '让孩子自主选择感兴趣的书，并以亲子共读、讨论故事的方式进行互动。少一些考核式提问，多一些倾听与分享，阅读的乐趣才能被真正点燃。' },
    ],
  },
  {
    id: 'l08',
    title: '一杯好咖啡的居家冲煮入门',
    summary: '不需要昂贵设备，掌握水温、比例与研磨三个变量，在家也能冲出一杯稳定好喝的手冲咖啡。',
    category: 'life',
    tags: ['实用', '美食'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-02T10:00:00',
    readCount: 12680,
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20pour%20over%20coffee%20set%20with%20steam%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=800&height=450&seq=entcov-l08&orientation=landscape',
    content: [
      { type: 'paragraph', text: '在家冲煮咖啡并不复杂，关键是把控好水温、粉水比例与研磨度这三个核心变量，找到适合自己的风味。' },
      { type: 'heading', text: '基础参数' },
      { type: 'paragraph', text: '手冲水温通常控制在九十摄氏度左右，粉水比例可以从一比十五起步，再根据口味微调。研磨度以中细为宜，避免过细导致苦涩。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20coffee%20beans%20and%20a%20cup%20on%20a%20table%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l08&orientation=landscape', caption: '把控核心变量冲出好咖啡（示意图）' },
      { type: 'heading', text: '注水与品鉴' },
      { type: 'paragraph', text: '注水时先少量焖蒸，再分次缓慢绕圈，让咖啡粉均匀萃取。喝之前不妨闻香、感受余韵，记录下来逐步调整，就能越来越接近理想的味道。' },
    ],
  },
  {
    id: 'l09',
    title: '冬季节能保暖家居改造攻略',
    summary: '通过门窗密封、合理保温与智能温控，几个低成本改造就能让冬天更暖和，同时减少供暖能耗。',
    category: 'life',
    tags: ['实用', '家居'],
    author: '9·1牛网 生活组',
    publishTime: '2026-10-01T09:15:00',
    readCount: 8940,
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20warm%20living%20room%20with%20blankets%20and%20a%20lamp%2C%20orange%20and%20deep%20blue%20palette%2C%20minimal%20editorial%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=entcov-l09&orientation=landscape',
    content: [
      { type: 'paragraph', text: '想让家里在冬天更暖和一些，未必需要大动干戈。通过一些低成本的小改造，就能在提升舒适度的同时减少热量流失。' },
      { type: 'heading', text: '门窗密封' },
      { type: 'paragraph', text: '门窗缝隙是热量流失的主要通道，加装密封条或挡风条，可以明显减少冷风渗入。夜间拉上厚实的窗帘，也能起到保温作用。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20home%20insulation%20and%20warm%20textiles%2C%20navy%20and%20orange%20palette%2C%20clean%20editorial%20style%2C%20no%20text&width=1000&height=560&seq=lifebody-l09&orientation=landscape', caption: '低成本改造提升保暖效果（示意图）' },
      { type: 'heading', text: '合理保温与温控' },
      { type: 'paragraph', text: '地面铺设地毯可以减少凉意，使用加湿器则能改善干燥。若家中有供暖设备，配合合理的时间安排与温控设置，取暖更高效也更省心。' },
    ],
  },
];

export const hotKeywords = ['最低工资标准', '电影票房', '秋季养生', '数字人民币', '音乐节', '家庭收纳', '高铁开通', '亲子阅读'];

export const tagOptions = ['突发', '深度', '热议', '观察', '实用'];